
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Link from "@/components/Link.vue";
import P5 from "p5";
import BookMenu from "@/components/BookMenu.vue";
import ColorScaleCompService from '@/services/ColorScaleComp.service';
import ColorScalesHeader from "@/components/ColorScalesHeader.vue";
import BackButton from "@/components/BackButton.vue";

const namespace = "BookModule";

@Component({
  components: {
    Link,
    BookMenu,
    ColorScalesHeader,
    BackButton
  },
})

export default class ArticleColorSpaces extends Vue{
  @Mutation('setSliderHue', {namespace}) private setSliderHue!: (value:number) => any;
  @Mutation('setSliderLuminance', {namespace}) private setSliderLuminance!: (value:number) => any;
  @State('sliderHue', { namespace }) private sliderHue!: number;
  @State('sliderLuminance', { namespace }) private sliderLuminance!:  number;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
    const script = function (p5: any){
      let scale;
      let sat = 50;
      //const amplitude = 93.727325;
      function pow3(f:any){
        return f*f*f; 
      }
      function LUVtoXYZ(L:any, U:any, V:any){
        let u, v, un, vn, X, Y, Z, Yn, Xn;
        
        //Constants
        const k = 0.0011070564598794539; //(3/29)^3
        
        // Ajustem la lluminància per a que estigui en el rang (0-100) i no (0-200)
        L*=2;
        
        if(L!=0){
          un = 0.2009;
          vn = 0.4610;
          
          Xn = 0.312713;
          Yn = 0.329016;
          
          u = U/(13.0*L) + un;
          v = V/(13.0*L) + vn;
          
          if(L<=8){
            Y = Yn * L * k;
          }else{
            Y = Yn * p5.pow((L+16)/116.0, 3);
          }
          
          X = (Y * 9 * u) / (4.0*v);
          Z = Y * (12-3*u-20*v)/(4*v);
          const colorArray =[X, Y, Z];
          return colorArray;
        }else{
          const colorArray = [0, 0, 0];
          return colorArray;
        }
      }
      function XYZtoRGB(X:any, Y:any, Z:any){
        const R = + 3.2406*X - 1.5372*Y - 0.4986*Z ;
        const G = - 0.9689*X + 1.8758*Y + 0.0415*Z ;
        const B = + 0.0555*X - 0.2040*Y + 1.0570*Z ;
        const colorArray = [R*255, G*255, B*255];
        return colorArray;
      }
      function LUVToRGB(L:any, U:any, V:any){
        const XYZColor = LUVtoXYZ(L, U, V);
        const RGBColor = XYZtoRGB(XYZColor[0], XYZColor[1], XYZColor[2]);
        return RGBColor;
      }
      function hueToRGB(hue:any, luminance:any){
        const L = luminance;
        if(p5.mouseY>0 && p5.mouseY<p5.height && p5.mouseX>0 && p5.mouseX<p5.width){
          sat = p5.map(p5.mouseX, 0, p5.width, 0, 100);
        }else{
          sat = 50;
        }
        const U = sat*p5.sin(p5.radians(hue));
        const V = sat*p5.cos(p5.radians(hue));  
        const RGBColor = LUVToRGB(L, U, V);
        return RGBColor;
      }
      class Tone {
        toneColor:any;
        constructor(colorHue:any, luminance:any){
          this.toneColor = hueToRGB(colorHue, luminance);
        }
      }
      class Scale {
        baseHue: number;
        luminance: number;
        cromaticScale: any;
        constructor(baseHue:any, luminance:any){
          this.baseHue = baseHue;
          this.luminance = 7.67*p5.sqrt(luminance);
          this.cromaticScale = this.get12Tones();
        }
        
        get12Tones(){
          const tones = [];
          for(let i=0; i<12; i++){
            tones[i] = new Tone((this.baseHue - i*30)%360, this.luminance); 
          }
          return tones;
        }
      }
      function displaySpectrum(x:any, y:any, w:any, h:any){
        let minLum = -1;
        let maxLum = 0;
        
        p5.push();
          p5.translate(x, y);
          for(let i=0; i<100; i+=0.5){
            scale = new Scale(90, i);
            let realColors = 0;
            for(let j=0; j<12; j++){
              const strokeColor = scale.cromaticScale[j].toneColor;
              p5.noStroke();
              p5.fill(strokeColor[0], strokeColor[1], strokeColor[2]);
              p5.rect(i*w/100, j*h/12, w/100, h/12);
              
              //Mostra la màscara per a veure només els que són reals.
              if(strokeColor[0]<0 || strokeColor[1]<0 || strokeColor[2]<0 || strokeColor[0]>255 || strokeColor[1]>255 || strokeColor[2]>255 
              || (strokeColor[0]==0 && strokeColor[1]==0 && strokeColor[2]==0)){
                p5.fill(0);
                p5.rect(i*w/100, j*h/12, w/100, h/12);
              }else{
                realColors++;
              }
            }
            if(minLum == -1 && realColors==12){
              minLum = i;
            }
            if(realColors==12){
              maxLum = i; 
            }
          }
          p5.stroke(255,0,0);
          p5.line(x+minLum*w/100, y, x+minLum*w/100, y+h);
          p5.line(x+(maxLum+0.5)*w/100, y, x+(maxLum+0.5)*w/100, y+h);
          p5.noStroke();
          p5.textAlign(p5.LEFT);
          p5.text("minLum = " + minLum, 15, y+h+25);
          p5.text("maxLum = " + maxLum, 115, y+h+25);
          p5.text("sat = " + p5.int(sat), 215, y+h+25);
          p5.textSize(20);
          p5.textAlign(p5.CENTER);
          if(!(p5.mouseX>0&&p5.mouseX<p5.width&&p5.mouseY>0&&p5.mouseY<p5.height)){
            p5.text("Move the cursor from left to right to change the saturation", p5.width/2, p5.height/2);
          }
        p5.pop();
      }
      function escalaReal(escala:any){
        for(let i=0; i<12; i++){
          const to = escala.cromaticScale[i].toneColor;
          if(to[0]<0 || to[0]>255 || to[1]<0 || to[1]>255 || to[2]<0 || to[2]>255){
            return false;
          }
        }
        return true;
      }
      p5.setup = (_:any) => {   
        const canvas = p5.createCanvas(document.body.clientWidth*0.6,340);   
        canvas.parent("p5Canvas");  
      }    
      p5.draw = (_:any) => {    
        p5.background(128);
        displaySpectrum(0, 0, p5.width, 300);  
      }  
    }
    const myP5 = new P5(script);
  }

  private handleHueSlider(event:any){
    this.setSliderHue(parseInt(event.target.value));
  }

  private handleLuminanceSlider(event:any){
    this.setSliderLuminance(event.target.value);
  }

  private getColor() : string {
    return ColorScaleCompService.HLtoHEX(this.sliderHue, this.sliderLuminance);
  }
};
